module.exports = __webpack_public_path__ + "static/img/Joseph-Sua'ali'i.7ed2faa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joseph-Sua'ali'i.jpg
// module id = RTsk
// module chunks = 0